// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip__content[data-v-646342cd] {\n  pointer-events: initial;\n}", ""]);
// Exports
module.exports = exports;
